export default __webpack_public_path__ + "static/media/sitemap.b98a372f.webp";